import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const Label = styled("label")(() => ({
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  fontFamily: "Manrope",
  color: "#475467",
  marginBottom: "0px",
}));

export const Value = styled("span")(() => ({
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  fontFamily: "Manrope",
  color: "#475467",
}));

export const ValueEmpty = styled(Value)(() => ({
  color: "#9CA6AF",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ValueArrayWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  minHeight: "fit-content",
  gap: 8,
  textWrap: "nowrap",
}));
